<template>
    <modal ref="modal" unclosable>
        <div id="title" v-html="$t('modals.invalid_device.title')"></div>
        <div id="text" v-html="$t('modals.invalid_device.text')"></div>
        <img src="~@/assets/img/invalid_device.png"/>
        <button v-on:click="hide">{{ $t('modals.invalid_device.button') }}</button>
    </modal>
</template>

<script>
export default {
  methods: {
    show () {
      this.$refs.modal.show()
    },
    hide () {
      this.$refs.modal.hide()
    }
  }
}
</script>

<style scoped>

/* Large desktop */
@media (min-width: 1200px) {

    #text {
      max-width: 40em;
    }

    img {
      width: 35em;
    }

}

/* Portrait tablet to landscape and desktop */
@media (min-width: 768px) and (max-width: 1199px) {

    #text {
      max-width: 40em;
    }

    img {
      width: 35em;
    }

}

/* Landscape phone to portrait tablet */
@media (min-width: 481px) and (max-width: 767px) {

    #text {
      max-width: 40em;
    }

    img {
      width: 35em;
    }

}

/* Landscape phones and down */
@media (max-width: 480px) {

    img {
      width: 100%;
    }

    button {
      width: 100%;
    }

}

#title {
  color: #000000;
  font-size: 2em;
  font-weight: 400;
  margin: 0 0 1em 0;
}

#text {
  margin: 0 0 1.5em 0;
}

img {
  display: block;
  margin: auto auto 2em auto;
}

</style>
